/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps } from '@wordpress/block-editor';

/**
 * The save function defines the way in which the different attributes should
 * be combined into the final markup, which is then serialized by the block
 * editor into `post_content`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#save
 *
 * @return {WPElement} Element to render.
 */
export default function save( props ) {
	const { attributes } = props;
	const { textAlign, icon, linkURL, iconType, style, customSVG } = attributes;

	const getStyleVariable = () => {
		const variables = {};

		// Handle link color
		const linkColorToken = style?.elements?.link?.color?.text;
		if (linkColorToken) {
			const match = linkColorToken.match(/var:preset\|color\|(.+)/);
			if (match) {
				variables['--var-svg-color'] = `var(--wp--preset--color--${match[1]})`;
			}
		}

		// Handle font size
		const fontSizeToken = style?.typography?.fontSize;
		if (fontSizeToken) {
			const match = fontSizeToken.match(/var:preset\|font-size\|(.+)/);
			if (match) {
				variables['--var-svg-font-size'] = `var(--wp--preset--font-size--${match[1]})`;
			} else {
				// If it's a raw value like '20px', use it directly
				variables['--var-svg-font-size'] = fontSizeToken;
			}
		}

		return variables;
	};;

	const blockProps = useBlockProps.save({
		style: getStyleVariable(),
	});
	return (
		<>
			{
				linkURL == "" || linkURL == null
					?
					<div id="wptravel-blocks-icon" style={ {textAlign: textAlign} } { ...blockProps } >
						<div style={ {textAlign: textAlign} }>
							{iconType === 'fontawesome' ? (
								<i className={icon} aria-hidden="true"></i>
							) : (
								<div
									className="custom-svg-icon"
									dangerouslySetInnerHTML={{ __html: customSVG }}
								/>
							)}
						</div>
						
					</div>
					: 
					<div id="wptravel-blocks-icon" style={ {textAlign: textAlign} } { ...blockProps } >
						<div style={ {textAlign: textAlign} }>
							<a href={linkURL}>
								{iconType === 'fontawesome' ? (
								<i className={icon} aria-hidden="true"></i>
								) : (
									<div
										className="custom-svg-icon"
										dangerouslySetInnerHTML={{ __html: customSVG }}
									/>
								)}
							</a>
						</div>
						
					</div>
			}
		</>
	);
}